import {
   AdamedExpertExternalFault,
   AdamedExpertRedirectCommand,
   AuthorizationRequiredFault,
   InvalidCredentialsFault,
} from '@dreryk/egabinet-adamed-expert-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { createInterpolatedTranslationKey } from '@dreryk/react-common';
import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { translationKeys } from './translations';

type AdamedExpertAuthenticateCommandParameters = {
   openModal: VoidFunction;
};

export const useAdamedExpertAuthenticateCommand = (): UseCqrsCommandResult<
   string,
   AdamedExpertAuthenticateCommandParameters,
   AuthorizationRequiredFault | InvalidCredentialsFault | AdamedExpertExternalFault
> => {
   return useCqrsCommand(
      () => {
         return new AdamedExpertRedirectCommand();
      },
      {
         onSuccess: (result) => {
            window.open(result, '_blank');
         },
         onFault: {
            'egabinet-adamed-expert-frontend-api:AuthorizationRequiredFault': (_, parameters) => {
               parameters.openModal();
            },
            'egabinet-adamed-expert-frontend-api:InvalidCredentialsFault': (_, parameters) => {
               parameters.openModal();
               dispatchSnackbarNegativeEvent(translationKeys.modal.authenticate.invalidCredentialsFault);
            },
            'egabinet-adamed-expert-frontend-api:AdamedExpertExternalFault': ({ message }) => {
               dispatchSnackbarNegativeEvent(
                  createInterpolatedTranslationKey(translationKeys.externalSystemBusinessFault, {
                     messageFromAdamedExpert: message,
                  })
               );
            },
         },
      }
   );
};
